import React, { useContext } from 'react';

// Styles & Assets
import styles from './GeneralGraphPatient.module.css';

// Services
import { getCVParams, getScore } from '../../../services/General';

// Hooks
import { useTranslation } from 'react-i18next';

// Context
import ColumnsContext from '../../../context/ColumnsContext';
import ScoresContext from '../../../context/ScoresContext';

// Components
import SonarTableChart from '../../PatientsPage/SonarTableChart/SonarTableChart';

// Interfaces
import { Patient } from '../../../interfaces/Patient';
interface Props {
    patient: Patient
}

const GeneralGraphPatient: React.FC<Props> = ({ patient }) => {

    const { t } = useTranslation();

    const { cellsSonarSelected } = useContext(ColumnsContext);
    const { scores } = useContext(ScoresContext);

    const cellID = cellsSonarSelected[patient.id];

    const paramConfig = getCVParams(cellID);
    const score = getScore(cellID, scores);

    return (
        < div className={styles.CVGraphContainer} >
            <p>{t('trend')} {t(paramConfig?.name || score?.name || '')}</p>
            {patient && patient.cases.length > 0 && patient.cases[0] &&
                <SonarTableChart
                    case_id={patient.cases[0].id}
                    patientID={patient.id}
                    generalInfo
                />
            }
        </div >
    );
};

export default GeneralGraphPatient;